<!-- Copyright (C) 2024-2026 Skylark Drones -->
<template>
  <div class="d-inline-flex elevation-2 rounded-pill primary">
    <v-btn
      color="primary"
      rounded
      depressed
      class="rounded-r-0"
      @click="selectFile"
    >
      <v-icon left>mdi-tray-arrow-up</v-icon>
      Upload Site
    </v-btn>
    <v-divider vertical class="ma-0" />
    <v-menu v-model="showMenu" bottom offset-y left nudge-bottom="6">
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="primary"
          rounded
          depressed
          class="px-2 rounded-l-0"
          style="min-width: unset"
        >
          <v-icon :style="{ transform: showMenu ? 'rotate(180deg)' : null }">
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-list class="pa-0 ma-0 rounded-lg">
        <v-list-item @click="onDrawSite">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-draw</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Draw Site</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="showCreateCollectionDialog = true">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-folder-plus-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Create Collection</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <site-file-selector-module
      v-show="false"
      ref="inputUpload"
      @file-processed="onFileProcessed"
    />

    <invalid-site-file-dialog
      v-if="showInvalidSiteFileDialog"
      :title="errorTitle"
      :message="errorMsg"
      @close-dialog="showInvalidSiteFileDialog = false"
      @select-another-file="onInvalidFileSelected"
    />
    <create-new-collection-dialog
      v-if="showCreateCollectionDialog"
      @close-dialog="showCreateCollectionDialog = false"
      @collection-created="onCollectionCreated"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import UploadSiteBtnMixin from './UploadSiteBtnMixin'

const CreateNewCollectionDialog = () =>
  import('@/components/collections/CreateNewCollectionDialog.vue')

export default {
  name: 'UploadSiteBtn',
  mixins: [UploadSiteBtnMixin],

  components: {
    CreateNewCollectionDialog
  },

  data() {
    return {
      showMenu: false,
      showCreateCollectionDialog: false
    }
  },

  computed: {
    ...mapGetters(['currentActiveOrganizationId'])
  },

  methods: {
    ...mapMutations(['updateNotificationPayload']),
    async onDrawSite() {
      this.$analytics.trackSiteDraw()
      await this.$router.push({
        name: 'SiteDetailsPage',
        params: {
          companyId: this.currentActiveOrganizationId,
          siteId: 'new',
          workflow: 'draw',
          site: null
        }
      })
    },
    onCollectionCreated(collectionId) {
      this.showCreateCollectionDialog = false
      this.updateNotificationPayload({
        message: 'Collection created successfully',
        code: 201,
        timeout: 5000
      })
      this.$router.push({
        name: 'CollectionDetailsPage',
        params: {
          companyId: this.currentActiveOrganizationId,
          collectionId
        }
      })
    }
  }
}
</script>
